export const ORDER_ACTION_CONFIG = {
    CREATE_ORDER: {
        color: 'success',
        icon: 'fa-circle-plus',
        label: 'Order Created',
        description: 'A new order was created for this movieversion'
    },
    UPDATE_ORDER: {
        color: 'success',
        icon: 'fa-pen-to-square',
        label: 'Order Updated',
        description: 'An existing order was updated'
    },
    SYNC_ORDER_FROM_CLOUD: {
        color: 'info',
        icon: 'fa-cloud-arrow-down',
        label: 'Synced From Cloud',
        description: 'Order state was synced down from the cloud'
    },
    DEPRECATE_ORDER: {
        color: 'warning',
        icon: 'fa-box-archive',
        label: 'Order Deprecated',
        description: 'An existing order was deprecated'
    },
    SKIP_EXISTING_REAL_ORDER: {
        color: 'secondary',
        icon: 'fa-forward',
        label: 'Skipped (Real Order)',
        description: 'Skipped because a real order already exists'
    },
    NO_ORDER_ORG_MISMATCH: {
        color: 'danger',
        icon: 'fa-triangle-exclamation',
        label: 'No Order: Org Mismatch',
        description: 'Organization does not match territory, tier or availability - check the configuration'
    },
    NO_ORDER_MOVIE_NOT_PUBLISHED: {
        color: 'warning',
        icon: 'fa-eye-slash',
        label: 'No Order: Not Published',
        description: 'The movie is not published'
    },
    NO_ORDER_ACTION: {
        color: 'warning',
        icon: 'fa-circle-minus',
        label: 'No Order Action',
        description: 'No order action was taken for this event'
    }
};

export const EVENT_TYPE_CONFIG = {
    movieversion_created: {
        color: 'primary',
        icon: 'fa-plus',
        label: 'MV Created',
        description: 'A new movieversion appeared during the sync'
    },
    movieversion_updated: {
        color: 'info',
        icon: 'fa-pen',
        label: 'MV Updated',
        description: 'An existing movieversion changed during the sync'
    }
};

// Documents are written by an external cron, so values outside the known
// enums must still render
export const getOrderActionConfig = (orderAction) =>
    ORDER_ACTION_CONFIG[orderAction]
    || { color: 'secondary', icon: 'fa-circle-question', label: orderAction || 'Unknown', description: '' };

export const getEventTypeConfig = (eventType) =>
    EVENT_TYPE_CONFIG[eventType]
    || { color: 'secondary', icon: 'fa-circle-question', label: eventType || 'Unknown', description: '' };
